import * as fromGenerated from '../../../_generated';

/**
 * Sort assistants by name.
 */
export const sortAssistantsComparer = (
  assistantA: Pick<fromGenerated.AssistantView, 'name'>,
  assistantB: Pick<fromGenerated.AssistantView, 'name'>,
): number =>
  assistantA.name.localeCompare(assistantB.name, undefined, {
    caseFirst: 'upper',
  });
